import { render, staticRenderFns } from "./bj.vue?vue&type=template&id=89e55c4c&scoped=true&"
import script from "./bj.vue?vue&type=script&lang=js&"
export * from "./bj.vue?vue&type=script&lang=js&"
import style0 from "./bj.vue?vue&type=style&index=0&id=89e55c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e55c4c",
  null
  
)

export default component.exports